import './helpers.js';

import App from './App.svelte';

//window.addEventListener('load', () => setTimeout(() => window.scrollTo(0, 0), 0));

const app = new App({target: document.body});

export default app;
